import React from 'react';

interface WebpLazyImageProps {
    src?: string,
    webpSrc?: string,
    alt?: string,
    className?: string,
    width?: number,
    height?: number,
}

const WebpLazyImage: React.FC<WebpLazyImageProps> = ({src, webpSrc, alt, className, width, height}) => {
    return <picture>
        {webpSrc && <source srcSet={webpSrc} type="image/webp"/>}
        <img loading="lazy" src={src} alt={alt} className={className}/>
    </picture>
};

export default WebpLazyImage;
